import { CheckmarkCircle, X } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';
import type { Toast } from 'react-hot-toast';
import toast from 'react-hot-toast';

export const PairingCompleteToast = (t: Toast) => (
  <div className="rounded-sm m-auto flex animate-fade-in-down flex-col bg-neutral-light-3 p-16 shadow-md md:m-0">
    <div className="flex items-center justify-start gap-8">
      <CheckmarkCircle size={16} />
      <Typography variant="body-md" fontWeight="bold" as="span">
        Pairing completed
      </Typography>
    </div>
    <Typography variant="body-md" className="mr-8" as="p">
      You&apos;ve successfully paired your device.
    </Typography>

    <button
      className="absolute top-0 right-0 cursor-pointer p-16"
      onClick={() => toast.remove(t.id)}
      aria-label="Close"
    >
      <X />
    </button>
  </div>
);
